import React, { useEffect, useState } from "react";
import { FormSection } from "..";

export default function FormGrouping({ children, title, borderBottomWidth }) {
  const [depsOpen, setDepsOpen] = useState(true);

  return (
    <div className="main-content">
      <div className="container__title-content">
        <FormSection
          title={title}
          borderBottomWidth={borderBottomWidth}
        ></FormSection>
      </div>

      <div className={`global-input-container slide`}>
        {children}
      </div>
    </div>
  );
}
